import React from "react";
import { createComponent } from "@lit/react";
import { BeamPostPurchase as _BeamPostPurchase } from "./index";

export const BeamPostPurchase = createComponent({
  tagName: _BeamPostPurchase.tagName,
  elementClass: _BeamPostPurchase,
  react: React,
  events: {},
});

export default BeamPostPurchase; // default alias for use with async import utils like next/dynamic and react.lazy
